<template>
  <card id="clusterOverview" :title="$t('c-overview:overview', {count: endDevices.totalCount})" no-footer>
    <template #card-body>
      <overview-bars :title="$t('c-overview:statuses')" :repartition="statusRepartition" />

      <overview-bars class="mt-4" :title="$t('c-overview:dataRates')" :repartition="dataRateRepartition" />

      <overview-bars class="mt-4" :title="$t('c-overview:dataUp')" :repartition="dataUpRepartition" />
    </template>
  </card>
</template>

<script>
import { each, filter, upperFirst } from 'lodash-es'
import endDevicesStatuses from '@/configuration/endDevicesStatuses'
import { clusterOverviewDatarates } from '@/configuration/regions'
import OverviewBars from './OverviewBars'

export default {
  components: { OverviewBars },

  props: {
    endDevices: {
      type: Object,
      required: true
    }
  },

  computed: {
    totalCount () { return this.endDevices.totalCount },

    statusRepartition () {
      const statusRepartition = []
      each(endDevicesStatuses, status => {
        const endDevices = filter(this.endDevices.list, ed => ed.status === status.value)
        statusRepartition.push({
          id: status.value,
          name: upperFirst(this.$t('endDevices:statuses.' + status.value)),
          value: endDevices.length,
          percentage: this.totalCount ? endDevices.length / this.totalCount * 100 : 0,
          color: status.color,
          onClick: () => this.goToEndDevices(status)
        })
      })

      return statusRepartition
    },

    dataRateRepartition () {
      // Filter to only use end-devices with DATAUP_SUCCESS status
      const endDevicesDUS = filter(this.endDevices.list, ed => ed.status === 'DATAUP_SUCCESS')

      const dataRateRepartition = []
      each(clusterOverviewDatarates, dr => {
        const endDevices = filter(endDevicesDUS, ed => ed.lastDataUpDataRate === dr.value)
        dataRateRepartition.push({
          id: dr.value,
          name: upperFirst(dr.label),
          value: endDevices.length,
          percentage: endDevicesDUS.length ? endDevices.length / endDevicesDUS.length * 100 : 0,
          color: dr.color
        })
      })

      return dataRateRepartition
    },

    dataUpRepartition () {
      // Filter to only use end-devices with DATAUP_SUCCESS status
      const endDevicesDUS = filter(this.endDevices.list, ed => ed.status === 'DATAUP_SUCCESS')

      const lastHour = filter(endDevicesDUS, ed => ed.lastDataUpDate >= Date.now() - 1000 * 60 * 60)
      const lastDay = filter(endDevicesDUS, ed => ed.lastDataUpDate >= Date.now() - 1000 * 60 * 60 * 24)
      const lastWeek = filter(endDevicesDUS, ed => ed.lastDataUpDate >= Date.now() - 1000 * 60 * 60 * 24 * 7)
      const lastMonth = filter(endDevicesDUS, ed => ed.lastDataUpDate >= Date.now() - 1000 * 60 * 60 * 24 * 30)
      const lastYear = filter(endDevicesDUS, ed => ed.lastDataUpDate >= Date.now() - 1000 * 60 * 60 * 24 * 365)
      const overLastYear = filter(endDevicesDUS, ed => ed.lastDataUpDate < Date.now() - 1000 * 60 * 60 * 24 * 365)

      const lastHourNb = lastHour.length
      const lastDayNb = Math.max(lastDay.length - lastHour.length, 0)
      const lastWeekNb = Math.max(lastWeek.length - lastDay.length, 0)
      const lastMonthNb = Math.max(lastMonth.length - lastWeek.length, 0)
      const lastYearNb = Math.max(lastYear.length - lastMonth.length, 0)
      const overLastYearNb = Math.max(overLastYear.length - lastYear.length, 0)

      const dataRateRepartition = []
      dataRateRepartition.push({
        id: 'lastHour',
        name: upperFirst(this.$t('c-overview:lastHour')),
        value: lastHourNb,
        percentage: endDevicesDUS.length ? lastHourNb / endDevicesDUS.length * 100 : 0,
        color: '#4caf50'
      })

      dataRateRepartition.push({
        id: 'lastDay',
        name: upperFirst(this.$t('c-overview:lastDay')),
        value: lastDayNb,
        percentage: endDevicesDUS.length ? lastDayNb / endDevicesDUS.length * 100 : 0,
        color: '#8bc34a'
      })

      dataRateRepartition.push({
        id: 'lastWeek',
        name: upperFirst(this.$t('c-overview:lastWeek')),
        value: lastWeekNb,
        percentage: endDevicesDUS.length ? lastWeekNb / endDevicesDUS.length * 100 : 0,
        color: '#2196f3'
      })

      dataRateRepartition.push({
        id: 'lastMonth',
        name: upperFirst(this.$t('c-overview:lastMonth')),
        value: lastMonthNb,
        percentage: endDevicesDUS.length ? lastMonthNb / endDevicesDUS.length * 100 : 0,
        color: '#9c27b0'
      })

      dataRateRepartition.push({
        id: 'lastYear',
        name: upperFirst(this.$t('c-overview:lastYear')),
        value: lastYearNb,
        percentage: endDevicesDUS.length ? lastYearNb / endDevicesDUS.length * 100 : 0,
        color: '#ffa726'
      })

      dataRateRepartition.push({
        id: 'overLastYear',
        name: upperFirst(this.$t('c-overview:overLastYear')),
        value: overLastYearNb,
        percentage: endDevicesDUS.length ? overLastYearNb / endDevicesDUS.length * 100 : 0,
        color: '#fb8c00'
      })

      return dataRateRepartition
    }
  },

  methods: {
    goToEndDevices (status) {
      const filters = { status: [{ id: status.value, name: upperFirst(this.$t('endDevices:statuses.' + status.value)) }] }
      this.$store.commit('setEndDevicesFilters', filters)
      this.$router.push('/end-devices')
    }
  }
}
</script>
